import { flow } from 'es-toolkit';
import { SearchSchemaInput, SearchSchemaOutput } from '../pagination';

export function transformMap(input: SearchSchemaInput): SearchSchemaOutput {
  const { page, limit, sort, search, filter } = input;
  const result: Record<string, unknown> = { page, limit, search };

  filter?.forEach(([key, value]) => {
    result[key] = value;
  });

  if (sort) {
    result[sort[0]] = sort[1];
  }

  return result;
}

export function transformSearchToStateObject(
  input: SearchSchemaOutput,
): SearchSchemaInput {
  const { page = 1, limit = 10, sort, filter, search } = input;

  return {
    page,
    limit,
    search,
    sort: sort?.split(','),
    filter: filter?.map((f) => f.split(',')),
  };
}

export function mapInitialFilters(input: SearchSchemaOutput) {
  return flow(transformSearchToStateObject, transformMap)(input);
}
